module.exports = __webpack_public_path__ + "static/media/Stackers-dt-fr.6a69c713.jpg";